module.exports = __webpack_public_path__ + "img/digital pr.52ca8a2f.jpeg";